const $body = $('body');

$(document).ready(function () {
  initialize();
});

function utagExists() {
  return typeof utag !== 'undefined';
}

/**
 * Copies the `utagData` object values to the current utag data object
 * @param {Object} response - the response object from the server that contains a `utagData` object
 */
function copyResponseData(response) {
  if (!response) return;

  for (const key in response.utagData) {
    // eslint-disable-line no-restricted-syntax
    if (response.utagData.hasOwnProperty(key)) {
      // eslint-disable-line no-prototype-builtins
      utag.data[key] = response.utagData[key];
    }
  }
}

function initialize() {
  const notifyMeButton = document.querySelector('.notify-me-modal-button');
  if(notifyMeButton) {
    notifyMeButton.addEventListener('click', () => {
      if (typeof utag === 'undefined' || !utag) return;
      utag.data.event_name = 'pdp_backinstock_start';
      utag.link(utag.data);
    });
  }
  
  $body.on('product:backInStockComplete', function () {
    if (typeof utag === 'undefined' || !utag) return;
    utag.data.event_name = 'pdp_backinstock_complete';
    utag.link(utag.data);
  });
}